export default __webpack_public_path__ + "static/media/feature--submit.d85750bd.png";